module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "4"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    staticClass: "ml-2 mr-2",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$route.name) + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalData) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    class: ' ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.DateTypeFilter ||
        _vm.Filter.JobNoFilter ||
        _vm.Filter.clientFilter ||
        _vm.Filter.slineFilter ||
        _vm.Filter.TransportTypeFilter ||
        _vm.Filter.ShipemntTypeFilter ||
        _vm.Filter.PORFilter ||
        _vm.Filter.POLFilter ||
        _vm.Filter.PODFilter ||
        _vm.Filter.FPODFilter ||
        _vm.Filter.statusFilter ||
        _vm.Filter.commonFilter ||
        _vm.Filter.ShippingBillFilter ||
        _vm.Filter.invoiceNoFilter ||
        _vm.Filter.portNameFilter ||
        _vm.Filter.portCodeFilter ||
        _vm.Filter.fk_cu_id ||
        _vm.Filter.branchFilter ||
        _vm.Filter.dateRange.startDate ||
        _vm.Filter.dateRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.DateTypeFilter ||
    _vm.Filter.JobNoFilter ||
    _vm.Filter.clientFilter ||
    _vm.Filter.slineFilter ||
    _vm.Filter.TransportTypeFilter ||
    _vm.Filter.ShipemntTypeFilter ||
    _vm.Filter.PORFilter ||
    _vm.Filter.POLFilter ||
    _vm.Filter.PODFilter ||
    _vm.Filter.FPODFilter ||
    _vm.Filter.statusFilter ||
    _vm.Filter.commonFilter ||
    _vm.Filter.ShippingBillFilter ||
    _vm.Filter.invoiceNoFilter ||
    _vm.Filter.portNameFilter ||
    _vm.Filter.portCodeFilter ||
    _vm.Filter.fk_cu_id ||
    _vm.Filter.branchFilter ||
    _vm.Filter.dateRange.startDate ||
    _vm.Filter.dateRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.getPaymentList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getPaymentList', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('designation') == 'Admin') ? _c('b-button', {
    staticClass: "mr-2 btn-sm",
    attrs: {
      "variant": "primary",
      "disabled": _vm.getPaymentList.length <= 0
    },
    on: {
      "click": _vm.clearShippingBill
    }
  }, [(!_vm.isClearShippingBillProcessing) ? _c('span', [_vm._v("Clear Shipping Bill")]) : _c('span', [_c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }), _vm._v("\n              Processing...\n            ")], 1)]) : _vm._e(), _vm._v(" "), _c('b-form-group', {
    staticClass: "pull-right ml-1 mt-1"
  }, [_c('b-button', {
    staticClass: "d-flex align-items-center",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": _vm.triggerFileInput
    }
  }, [_c('md-icon', {
    staticClass: "md-size-1x nav-icon mr-2"
  }, [_vm._v("cloud_upload")]), _vm._v(" "), (_vm.isFileLoading) ? _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('span', {
    staticClass: "mr-2"
  }, [_vm._v("Uploading...")]), _vm._v(" "), _c('b-spinner', {
    attrs: {
      "small": ""
    }
  })], 1) : _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_vm._v("\n                Upload File\n              ")])], 1), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": ".xlsx, .xls"
    },
    on: {
      "change": _vm.handleFileUpload
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "p-3 text-center border rounded",
    class: _vm.isDragActive ? 'border-primary bg-light' : 'border-secondary',
    staticStyle: {
      "border-style": "dashed !important",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.triggerFileInput,
      "dragover": function($event) {
        $event.preventDefault();
      },
      "dragenter": function($event) {
        $event.preventDefault();
        _vm.isDragActive = true
      },
      "dragleave": function($event) {
        $event.preventDefault();
        _vm.isDragActive = false
      },
      "drop": function($event) {
        $event.preventDefault();
        _vm.handleFileDrop($event)
      }
    }
  }, [_c('strong', [_vm._v("Drag and drop Excel file here")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v("or click to browse (`.xlsx`, `.xls`)")])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getBulkShippingBillList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Container No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Container NO Filter",
      "id": "ContainerNoFilter",
      "name": "ContainerNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBulkShippingBillList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.ContainerNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ContainerNoFilter", $$v)
      },
      expression: "Filter.ContainerNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "commonFilter",
      "name": "commonFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBulkShippingBillList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Bill No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Shipping Bill No",
      "id": "ShippingBillFilterTop",
      "name": "ShippingBillFilterTop",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBulkShippingBillList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.ShippingBillFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ShippingBillFilter", $$v)
      },
      expression: "Filter.ShippingBillFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Invoice No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Invoice No",
      "id": "invoiceNoFilterTop",
      "name": "invoiceNoFilterTop",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBulkShippingBillList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.invoiceNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "invoiceNoFilter", $$v)
      },
      expression: "Filter.invoiceNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Port Name Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Port Name",
      "id": "portNameFilterTop",
      "name": "portNameFilterTop",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBulkShippingBillList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.portNameFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "portNameFilter", $$v)
      },
      expression: "Filter.portNameFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Port Code Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Port Code",
      "id": "portCodeFilterTop",
      "name": "portCodeFilterTop",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBulkShippingBillList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.portCodeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "portCodeFilter", $$v)
      },
      expression: "Filter.portCodeFilter"
    }
  })], 1)], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": function($event) {
        _vm.getBulkShippingBillList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Container No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Container NO Filter",
      "id": "ContainerNoFilter",
      "name": "ContainerNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBulkShippingBillList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.ContainerNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ContainerNoFilter", $$v)
      },
      expression: "Filter.ContainerNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Bill Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Shipping Bill Filter",
      "id": "ShippingBillFilter",
      "name": "ShippingBillFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBulkShippingBillList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.ShippingBillFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ShippingBillFilter", $$v)
      },
      expression: "Filter.ShippingBillFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Invoice No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Invoice No",
      "id": "invoiceNoFilter",
      "name": "invoiceNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBulkShippingBillList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.invoiceNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "invoiceNoFilter", $$v)
      },
      expression: "Filter.invoiceNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Port Name Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Port Name",
      "id": "portNameFilter",
      "name": "portNameFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBulkShippingBillList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.portNameFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "portNameFilter", $$v)
      },
      expression: "Filter.portNameFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Port Code Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Port Code",
      "id": "portCodeFilter",
      "name": "portCodeFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBulkShippingBillList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.portCodeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "portCodeFilter", $$v)
      },
      expression: "Filter.portCodeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Container Size Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Container Size Filter",
      "id": "ContSizeFilter",
      "name": "ContSizeFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBulkShippingBillList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.ContSizeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ContSizeFilter", $$v)
      },
      expression: "Filter.ContSizeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Approved By")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Approved By Filter",
      "id": "approvedBy",
      "name": "approvedBy",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBulkShippingBillList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.approvedBy),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "approvedBy", $$v)
      },
      expression: "Filter.approvedBy"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Emp Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Emp Name Filter",
      "id": "empNameFilter",
      "name": "empNameFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBulkShippingBillList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.empNameFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "empNameFilter", $$v)
      },
      expression: "Filter.empNameFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "commonFilter",
      "name": "commonFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBulkShippingBillList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Created User\n                ")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "fk_cu_id",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": function($event) {
        _vm.getBulkShippingBillList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.fk_cu_id),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "fk_cu_id", $$v)
      },
      expression: "Filter.fk_cu_id"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.getPaymentList,
      "fields": _vm.PaymentFields,
      "primary-key": "id_email_section",
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                  " + _vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage) + "\n                ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "confirm-bulk-port-expense",
    attrs: {
      "id": "confirm-bulk-port-expense",
      "title": "Confirm Shipping Bill",
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.errMSG && _vm.selectedRows.length > 0) ? _c('h4', {
    staticClass: "mt-3 error"
  }, [_vm._v(_vm._s(_vm.errMSG) + " ")]) : _vm._e()]), _vm._v(" "), (_vm.isBulkShippingBillProcessing) ? _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "mb-2 d-flex justify-content-between align-items-center"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Bulk upload progress")]), _vm._v(" "), _c('small', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.bulkProgressPercent) + "%")])]), _vm._v(" "), _c('b-progress', {
    staticClass: "mb-2",
    attrs: {
      "max": 100,
      "height": "1.25rem"
    }
  }, [_c('b-progress-bar', {
    attrs: {
      "value": _vm.bulkProgressPercent,
      "label": (_vm.bulkProgressPercent + "%"),
      "variant": _vm.bulkProgressPercent >= 100 ? 'success' : 'primary'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedRows.length > 0) ? _c('b-col', {
    staticClass: " mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "mr-2 btn-sm",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.getSlineImportData
    }
  }, [(!_vm.isBulkShippingBillProcessing) ? _c('span', [_vm._v("Bulk Shipping Bill")]) : _c('span', [_c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }), _vm._v("\n            Processing " + _vm._s(_vm.bulkProgressPercent) + "%\n          ")], 1)]), _vm._v(" "), _c('b-button', {
    staticClass: "mr-2 btn-sm",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.resetModal
    }
  }, [_vm._v("\n          Cancel\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedRows.length > 0) ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "items": _vm.selectedRows,
      "fields": _vm.confirmFields,
      "small": "",
      "responsive": "",
      "head-variant": "light"
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1))])]
      }
    }, {
      key: "pe_container_no",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.item.pe_container_no))]), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "error"
        }, [_vm._v(_vm._s(row1.item.validationResult.MSG))])]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedRows.length > 0) ? _c('b-col', {
    staticClass: " mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "mr-2 btn-sm",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.getSlineImportData
    }
  }, [(!_vm.isBulkShippingBillProcessing) ? _c('span', [_vm._v("Bulk Shipping Bill")]) : _c('span', [_c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }), _vm._v("\n            Processing " + _vm._s(_vm.bulkProgressPercent) + "%\n          ")], 1)]), _vm._v(" "), _c('b-button', {
    staticClass: "mr-2 btn-sm",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.resetModal
    }
  }, [_vm._v("\n          Cancel\n        ")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "confirmClearPort",
    attrs: {
      "md-title": _vm.alert.title,
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onConfirmClearPort
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25ca4693","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/shipping_bill_mapper/shippingBillUpload.vue
// module id = 2469
// module chunks = 0